import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import { fetchPardotFields, fetchPardotMappings, patchPardotMappings } from 'app/modules/pardot/actions'
import { fetchAttributes } from 'app/modules/endUser/attribute/actions'
import { filteredProperties } from 'app/modules/endUser/attribute/selectors'
import { getFields, getMappings, didPatchErr, isPatchLoading } from 'app/modules/pardot/selectors'
import AttributeMapper from '../../components/AttributeMapper'
import { PardotMapping } from 'app/modules/pardot/models'
import { Input } from '@driftt/tide-core-legacy'
import withNotifications from 'components/shared/notifications'
import { PARDOT_APP_ID } from 'constants/ResourcesConstants'

 import './style.styl'

 const HELP_DOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360021057613-Drift-and-Pardot'
const integrationName = "Pardot"
const getSuccessMessage = (integrationName) => `You successfully updated your ${integrationName} App!`

 class PardotAttributeMapping extends Component {
  constructor(props){
    super(props)
    this.state = {
      mappings: props.mappings
    }
  }

   componentWillReceiveProps(nextProps){
    if (this.state.mappings !== nextProps.mappings) {
      this.setState({mappings: nextProps.mappings})
    }
  }

   componentDidMount() {
    this.props.actions.fetchDriftProperties()
    this.props.actions.fetchPardotFields()
    this.props.actions.fetchPardotMappings()
  }

   patchDecorator = (strippedMappings, successCB) => {
    const payload = {mappings: strippedMappings}
    this.props.actions.patchPardotMappings(payload, successCB)
  }

   render() {
    const { patchLoading, driftProperties, pardotFields, actions, notifications } = this.props
    const { mappings } = this.state
    return (
      <div className="pardot-mapping common-integration-page-layout">
        <IntegrationBreadcrumb
          backLinkText="Pardot Integration"
          backLinkUrl={`/settings/setup/pardot`}
        />
        <header>
          <h2 className="integration-header">Mapped Pardot Attributes</h2>
          <p> Map which fields you want to add to new Pardot Prospects. These Drift attributes will be added to new Pardot Prospects when they’re created. 
            <a href={HELP_DOC_URL}> Learn More</a>
          </p>
        </header>
        <AttributeMapper
          integrationName="Pardot"
          mappings={mappings}
          driftAttributes={driftProperties}
          integrationAttributes={pardotFields}
          mappingModel={PardotMapping}
          patchMappings={this.patchDecorator}
          patchLoading={patchLoading}
          allowAttributeDefaults={true} />
      </div>
    )
  }
}

PardotAttributeMapping.defaultProps = {
  allowAttributeDefaults: false
}

function mapStateToProps(state) {
  return {
    driftProperties: filteredProperties(state),
    mappings: getMappings(state),
    pardotFields: getFields(state),
    patchError: didPatchErr(state),
    patchLoading: isPatchLoading(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchDriftProperties: fetchAttributes,
      fetchPardotMappings,
      fetchPardotFields,
      patchPardotMappings
    }, dispatch)
  }
}

export default withNotifications(connect(mapStateToProps, mapDispatchToProps)(PardotAttributeMapping))


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/PardotAttributeMapping/index.js